__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "reactroot";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("i18next", "23.16.8", () => (__webpack_require__.e("vendor-vendors-_yarn_cache_i18next-npm-23_16_8-cb9903113e-d5c38011de_zip_node_modules_i18next-c94959").then(() => (() => (__webpack_require__("../../.yarn/cache/i18next-npm-23.16.8-cb9903113e-d5c38011de.zip/node_modules/i18next/dist/esm/i18next.js"))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-dom-virtual-8da4c5617b_0_cache_react-dom-npm-18_2_0-dd675bca1c-7986d5"), __webpack_require__.e("vendor-_yarn___virtual___react-dom-virtual-8da4c5617b_0_cache_react-dom-npm-18_2_0-dd675bca1c-5ee1d5"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__("../../.yarn/__virtual__/react-dom-virtual-8da4c5617b/0/cache/react-dom-npm-18.2.0-dd675bca1c-ca5e7762ec.zip/node_modules/react-dom/index.js"))))));
			register("react-i18next", "15.6.0", () => (Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-i18next-virtual-3edfb50658_0_cache_react-i18next-npm-15_6_0-59-d484e8"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__("../../.yarn/__virtual__/react-i18next-virtual-3edfb50658/0/cache/react-i18next-npm-15.6.0-59765b2326-d8549c364e.zip/node_modules/react-i18next/dist/es/index.js"))))));
			register("react-i18next", "15.6.0", () => (Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-i18next-virtual-73aa8e8042_0_cache_react-i18next-npm-15_6_0-59-24d63f"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__("../../.yarn/__virtual__/react-i18next-virtual-73aa8e8042/0/cache/react-i18next-npm-15.6.0-59765b2326-d8549c364e.zip/node_modules/react-i18next/dist/es/index.js"))))));
			register("react", "18.2.0", () => (__webpack_require__.e("react-_yarn_cache_react-npm-18_2_0-1eae08fee2-b9214a9bd7_zip_node_modules_react_index_js").then(() => (() => (__webpack_require__("../../.yarn/cache/react-npm-18.2.0-1eae08fee2-b9214a9bd7.zip/node_modules/react/index.js"))))));
			initExternal("webpack/container/reference/hlContentDesigner");
			initExternal("webpack/container/reference/hlReactRootLegacy");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};